// extracted by mini-css-extract-plugin
export default {"account_buy_add":"MultipleTopUpComp_account_buy_add__rcvhc","selected":"MultipleTopUpComp_selected__+c8Is"};